// @flow
import React from 'react'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import type { DesignBoardItem } from '../types'
import { colors } from '../styles'
import { actions } from '../store'

type Props = {
  item: DesignBoardItem,
  onClick: Function
}

const SharedOptions = [
  [
    {
      icon: 'trash-alt',
      label: 'Remove',
      action: actions.REMOVE_ITEM
    },
  ],
  [
    {
      icon: 'sort-amount-up-alt',
      label: 'Bring to front',
      action: actions.REORDER_ITEM,
      place: 'front'
    },
    {
      icon: 'sort-amount-down-alt',
      label: 'Push to back',
      action: actions.REORDER_ITEM,
      place: 'back'
    },
  ]
]

const TextOptions = [
  ...SharedOptions,
  [
    {
      icon: 'align-left',
      label: 'Align Left',
      action: actions.UPDATE_ITEM_ATTR,
      key: 'align',
      value: 'left'
    },
    {
      icon: 'align-center',
      label: 'Align Center',
      action: actions.UPDATE_ITEM_ATTR,
      key: 'align',
      value: 'center'
    },
    {
      icon: 'align-right',
      label: 'Align Right',
      action: actions.UPDATE_ITEM_ATTR,
      key: 'align',
      value: 'right'
    }
  ]
]

const ImageOptions = [
  ...SharedOptions,
]

export const Toolbar = (props: Props) => {

  // console.log('Toolbar', props)
  const isText = props.item?.text?.label
  const options = isText ? TextOptions : ImageOptions

  return (
    <Options>
      {options.map((optGroup, i) => (
        <React.Fragment key={`group-${i}`}>
          {i === 0 ? null : <Separator />}
          {optGroup.map((opt, j) => (
            <StyledIcon key={`icon-${j}`} onClick={() => props.onClick(opt)} title={opt.label}>
              <FontAwesomeIcon icon={[ 'fas', opt.icon ]} />
            </StyledIcon>
          ))}
        </React.Fragment>
      ))}
    </Options>
  )
}

const Options = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
`

const Separator = styled.div`
  display: inline-block;
  border-right: 1px solid ${colors.darkGray};
  height: 16px;
  margin: 0 0.5rem;
`

const StyledIcon = styled.button`
  display: inline-block;
  border: 0;
  background: transparent;
  padding: 0.5rem 0.5rem 0.25rem;
`
